import { render, staticRenderFns } from "./7TransverseFixation.vue?vue&type=template&id=ca61c7ee&scoped=true&"
import script from "./7TransverseFixation.vue?vue&type=script&lang=js&"
export * from "./7TransverseFixation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca61c7ee",
  null
  
)

export default component.exports